var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "data-coloringtype": "stroke",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 4,
  stroke: "#000",
  strokeOpacity: 0.9,
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeOpacity: 0.9,
  strokeWidth: 1.5,
  d: "M12 20c-7 0-11-8-11-8s4-8 11-8 11 8 11 8-4 8-11 8Z"
})));
export default SvgEye;